import React from 'react';

function TagsList({ classNames, employeesListSection, activeChips, handleChips }) {
    
    // hide tags that don't have associated users
    const filteredUsers = employeesListSection.map(user => user.fields.tagsList)
    const tags = filteredUsers.map((tag) => tag.map((t) => t.fields))
    const mergedTags = [].concat.apply([], tags);
    
    // const chipsToParse = mergedTags.filter((item, index) => mergedTags.indexOf(item) === index)
    
   const chipsToParse =  mergedTags.reduce(
      (unique, item) => (unique.includes(item.title) ? unique : [...unique, item.title]),
      [],
    );
    
    return (
        <div className={`${classNames} flex`}>
            {chipsToParse?.map((item, idx) => {
                return (
                    <div
                        className={`${classNames}_wrapper`}
                        key={idx}
                        data-active={activeChips.includes(item)}
                        onClick={() => handleChips(item)}>
                        <p className={`${classNames}_tip`}>{item}</p>
                    </div>
                );
            })}
        </div>
    );
}

export default TagsList;
